<template>
  <el-row class="padding-nav">
    <el-col :xs="24" :sm="24" :md="13" :lg="13">
      <el-button @click="goback" type="text" icon="el-icon-d-arrow-left" style="margin-bottom:0.16rem;"
        >Go back</el-button
      >
      <left-comp :tableMyList.sync="tableMyList"/>
    </el-col>
    <el-col :xs="24" :sm="24" :md="11" :lg="11">
      <div class="spaceCenter flexStart" style="min-height:6.4rem">
        <place-bid :lastBid.sync="lastBid" @refresh="refresh"/>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import leftComp from "./components/left.vue"
import placeBid from "./components/placeBid.vue"
import { auctionDetailList } from "@/api/auction.js"
export default {
  components: { leftComp, placeBid },
  data() {
    return {
      tableList:[],
      tableMyList:[]
    };
  },
  computed: {
    lastBid(){
      /*let sum = new this.BigNumber(0);
      this.tableMyList.forEach(i => {
        sum = sum.plus(i.amount);
      })
      return sum;*/
      return new this.BigNumber(this.tableMyList.length>0?this.tableMyList[0].amount:0);
    }
  },
  methods: {
    getMyBidList(){
      auctionDetailList({
        number:this.$route.query.number,
        account:this.$store.getters.metaMaskObj.account,
        pageSize:1000,
        page:1,
        sortField:"timestamp",
        sequence:"DESC",
        extractStatus:1
      }).then(res => {
        this.tableMyList = res.data ? res.data.data : [];
      }).catch(e => {
        console.log(e)
      })
    },
    refresh(){
      this.getMyBidList();
    },
    goback() {
      this.$router.push(this.$route.query.fromPath || "/TCashFinance/auction");
    }
  },
  created() {
    this.getMyBidList();
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.padding-nav {
  padding-left: 5%;
  padding-right: 5%;
}
.detail-title-1 {
  margin-bottom: 0.16rem;
}
.detail-title-2 {
  margin-top: 0.4rem;
}
.unit {
  font-size: 0.18rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
}
// .common-table {
//   ::v-deep  &.el-table {
//     font-size: 0.16rem;
//     background:#FAFAFA;

//     .el-table__header-wrapper th {
//       background:#FAFAFA;
//       color: #929DAD;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//     }
//     th.is-leaf{
//       border-bottom: none;
//     }
//     td {
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #4C4C4C;
//       line-height: 0.24rem;
//       background:#FAFAFA;
//       border-bottom: none;
//     }
//     &::before {
//       background: none;
//     }
//   }
//   .td-word-sm {
//     font-size: 0.16rem;
//     font-weight: 400;
//     color: #929dad;
//     line-height: 0.19rem;
//   }
// }
</style>
